module.exports = __webpack_public_path__ + "img/fig05.27d954c1.jpg";